import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ApiRouteConfig} from '../../config/api.route.config';

@Injectable()
export class FeedbackService {
  constructor(private httpClient: HttpClient, private config: ApiRouteConfig) {}

  public send(message: string): Observable<any> {
    return this.httpClient.post(this.config.FEEDBACK, {message});
  }
}
